module.exports = __webpack_public_path__ + "static/media/sonicbathtub3.bb373a1c.jpg";